import React from 'react'
import Qa from './FaQs'

const FaQs = (props) => (
  <Qa {...props} />
)

export default FaQs



// WEBPACK FOOTER //
// ./src/routes/FaQs/index.js